import NoContentSection from './NoContentSection';

export default NoContentSection;
